"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _shipmentPlan = _interopRequireDefault(require("../services/shipmentPlan"));

var useShipmentPlan = function useShipmentPlan(_ref) {
  var shipmentPlanUrl = _ref.shipmentPlanUrl,
      accessToken = _ref.accessToken;
  return (0, _reactQuery.useQuery)(['getShipmentPlanningData', shipmentPlanUrl, accessToken], function () {
    return (0, _shipmentPlan["default"])(shipmentPlanUrl, accessToken);
  }, {
    retry: false,
    enabled: shipmentPlanUrl
  });
};

var _default = useShipmentPlan;
exports["default"] = _default;